export default __webpack_public_path__ + "static/media/rotgutSL.5cd44628.jpg";